import { render } from "./PreviousTradingRules.vue?vue&type=template&id=7f2bb48d&scoped=true"
import script from "./PreviousTradingRules.vue?vue&type=script&lang=js"
export * from "./PreviousTradingRules.vue?vue&type=script&lang=js"

import "./PreviousTradingRules.vue?vue&type=style&index=0&id=7f2bb48d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2bb48d"]])

export default __exports__